import React from 'react'
import '../../styles/AboutPage.css'
import { SchoolPhoto, AboutOne, AboutTwo, AboutThree } from '../../assets/index'
import 'boxicons/css/boxicons.min.css';



const AboutPage = () => {
    return (
        <>
         
            <section id="hero" className="d-flex flex-column justify-content-end align-items-center" style={{ backgroundColor: '#172759' }}>
                <div
                    id="heroCarousel"
                    data-bs-interval="5000"
                    className="container carousel carousel-fade"
                    data-bs-ride="carousel"
                >
                    <div className="carousel-item active">
                        <div className="carousel-container">
                            <h2 className="animate__animated animate__fadeInDown">
                                We Don't Just Teach <span>We Transform</span>
                            </h2>
                            <p className="animate__animated animate__fadeInUp">
                                Our innovative curriculum, expert faculty, and hands-on learning approach prepare you to excel in the competitive business landscape. Choose FBS to unlock your potential and lead the future
                                From world-class mentorship to real-world exposure
                            </p>
                            <a href="#why-fbs" className="btn-get-started animate__animated animate__fadeInUp scrollto">
                                Read More
                            </a>
                        </div>
                    </div>




                </div>

                <svg
                    className="hero-waves"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28"
                    preserveAspectRatio="none"
                >
                    <defs>
                        <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g className="wave1">
                        <use xlinkHref="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
                    </g>
                    <g className="wave2">
                        <use xlinkHref="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
                    </g>
                    <g className="wave3">
                        <use xlinkHref="#wave-path" x="50" y="9" fill="#fff" />
                    </g>
                </svg>
            </section>

            {/* 
            <div className='about-img-container'>
                <img src={SchoolPhoto} />
            </div> */}

            <div className='about-why-fbs'>
                <div className="about-why-bg" style={{ backgroundImage: { SchoolPhoto } }}></div>
                <div className='about-why-content'>
                    <div className='about-why-heading' id='why-fbs'>
                        <span>Why FBS?</span>
                    </div>
                    <p>
                        Due to the lack of minimum practical exposure required on the job, Investment Banks and Equity Research firms DO NOT ENTERTAIN FRESHERS.
                        Hence, here is how FBS bridges the skill and experience gap and prepares you to be a ready-made resource available for employers!
                    </p>
                </div>
            </div>

            <div className="training-content">
                <section className="training-section">
                    <div className='about-training-text-div'>
                        <h2 className='about-us-h2-headings'>Practical & Case Study Based Training:</h2>
                        <ul>
                            <li><i className='bx bx-check'></i> Industry relevant content</li>
                            <li><i className='bx bx-check'></i> Case study based hands on training</li>
                            <li><i className='bx bx-check'></i> In-depth understanding of Finance fundamentals</li>
                            <li><i className='bx bx-check'></i> Trained by Investment Bankers</li>
                            <li><i className='bx bx-check'></i> Individual progress measurement</li>
                            <li><i className='bx bx-check'></i> Live internship with Financial Analyst Firm</li>
                            <li><i className='bx bx-check'></i> One on one doubt-clearing sessions</li>
                            <li><i className='bx bx-check'></i> Lifetime access to FBS LMS</li>
                            <li><i className='bx bx-check'></i> Connect with Financial Analyst professionals globally</li>
                        </ul>
                    </div>
                    <div className='about-training-img-div ' >

                        <img src={AboutOne} alt="Practical Training" />
                    </div>
                </section>

                <section className="training-section">
                    <div className='about-training-img-div'>

                        <img src={AboutTwo} alt="Interview Training" />
                    </div>
                    <div className='about-training-text-div' id='int' style={{ marginLeft: '2rem' }}>
                        <h2 className='about-us-h2-headings' >Interview Skill Training:</h2>
                        <ul>
                            <li><i className='bx bx-check'></i> Mock Interviews</li>
                            <li><i className='bx bx-check'></i> Frequently asked interview questions preparation</li>
                            <li><i className='bx bx-check'></i> Resume preparation</li>
                            <li><i className='bx bx-check'></i> Job portal updation</li>
                            <li><i className='bx bx-check'></i> Assertiveness and Communication</li>
                            <li><i className='bx bx-check'></i> Financial Model reading, Interpretation, Real business Case Studies, Reporting & Presentation</li>
                        </ul>
                    </div>
                </section>

                <section className="training-section">

                    <div className='about-training-text-div'>
                        <h2 className='about-us-h2-headings'>Market Ready:</h2>
                        <ul>
                            <li><i className='bx bx-check'></i> Frequent job updates</li>
                            <li><i className='bx bx-check'></i> Customized career guidance</li>
                            <li><i className='bx bx-check'></i> Soft skills workshop</li>
                            <li><i className='bx bx-check'></i> Skill set mapping</li>
                            <li><i className='bx bx-check'></i> Placement assistance</li>
                            <li><i className='bx bx-check'></i> Scheduling Interviews</li>
                        </ul>
                    </div>
                    <div className='about-training-img-div'>

                        <img src={AboutThree} alt="Market Ready" />
                    </div>
                </section>
            </div>

          
         
        </>
    )
}


export default AboutPage